import React from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../i18n';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-24 md:py-32 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, hsl(0 40% 97%) 0%, hsl(0 73% 96%) 50%, hsl(0 0% 100%) 100%)'
    }}>
      {/* Damask pattern */}
      <div className="absolute inset-0 damask-pattern opacity-30" />
      
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-40 h-40 bg-lavender/10 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-blush/20 rounded-full blur-3xl" />
      
      {/* Floating sparkles */}
      <div className="absolute top-1/4 right-1/4 text-gold/30 text-lg animate-twinkle">✦</div>
      <div className="absolute bottom-1/3 left-1/3 text-gold/25 text-base animate-twinkle delay-300">✦</div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center">
          {/* Decorative ornament */}
          <div className="mb-12">
            <svg className="w-20 h-20 text-lavender/35 mx-auto" viewBox="0 0 80 80" fill="currentColor">
              <path d="M40 10 C32 20 16 20 8 28 C16 34 32 34 40 48 C48 34 64 34 72 28 C64 20 48 20 40 10" />
              <circle cx="40" cy="28" r="5" fill="hsl(1 81% 35% / 0.4)" />
            </svg>
          </div>
          
          {/* Heart icon */}
          <div className="mb-10">
            <div className="w-20 h-20 rounded-full border-2 border-gold/40 flex items-center justify-center mx-auto bg-lavender-light/20">
              <Heart className="w-9 h-9 text-gold" fill="currentColor" />
            </div>
          </div>
          
          {/* Names */}
          <h2 className="font-script text-5xl md:text-6xl text-lavender mb-5">
            Jherli & Mirko
          </h2>
          
          {/* Date */}
          <p className="font-elegant text-2xl text-muted-foreground italic mb-12">
            {t('date.full')}
          </p>
          
          {/* Divider */}
          <div className="flex items-center justify-center gap-5 mb-12">
            <span className="w-24 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
            <div className="flex items-center gap-2">
              <span className="text-gold/50 text-sm">✿</span>
              <span className="text-lavender/50 text-lg">❦</span>
              <span className="text-gold/50 text-sm">✿</span>
            </div>
            <span className="w-24 h-px bg-gradient-to-l from-transparent via-gold/40 to-transparent" />
          </div>
          
          {/* Quote */}
          <div className="max-w-lg mx-auto mb-12">
            <p className="font-elegant text-xl text-muted-foreground italic leading-relaxed">
              &ldquo;{t('footer.quote')}&rdquo;
            </p>
            <p className="font-display text-sm text-muted-foreground mt-5 tracking-wider">
              — Antoine de Saint-Exupéry
            </p>
          </div>
          
          {/* Bottom section */}
          <div className="mt-16 pt-12 border-t border-lavender/15">
            <div className="flex items-center justify-center gap-4 mb-5">
              <span className="w-10 h-px bg-gold/30" />
              <span className="text-lavender/40">❦</span>
              <span className="w-10 h-px bg-gold/30" />
            </div>
            <p className="font-display text-xs text-muted-foreground tracking-[0.4em] uppercase mb-4">
              {t('footer.love')}
            </p>
            <p className="font-script text-3xl text-lavender">
              J & M
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
